export default __webpack_public_path__ + "static/media/fast-claims.5e049fd8.png";